import { z } from "zod";

/** Money is always a decimal string — never a JS number. Max 2 decimal places. */
export const moneySchema = z
  .string()
  .regex(/^\d{1,9}(\.\d{1,2})?$/, "가격은 소수점 둘째 자리까지의 숫자여야 합니다");

/** Postgres numeric(12,3) — three decimal places, needed for weight-based units (lb, kg). */
export const QTY_SCALE = 3;

/**
 * Quantities are decimal strings for the same reason money is: no float drift.
 * Whether a unit is divisible (is_divisible) and whether a value is a valid step multiple
 * can only be judged with the SKU in hand, so this only checks format and positivity.
 * The rest is enforced server-side by assertQtyAllowed (Task 9).
 */
export const quantitySchema = z
  .string()
  .regex(/^\d{1,9}(\.\d{1,3})?$/, "수량은 소수점 셋째 자리까지의 숫자여야 합니다")
  .refine((v) => Number(v) > 0, "수량은 0보다 커야 합니다");

/** At finalize time, the actually-delivered quantity may be 0 (supplier could not deliver). */
export const fulfilledQuantitySchema = z
  .string()
  .regex(/^\d{1,9}(\.\d{1,3})?$/, "수량은 소수점 셋째 자리까지의 숫자여야 합니다");

export const idSchema = z.uuid();

export const isoDateTimeSchema = z.iso.datetime({ offset: true });
